/**
 * Which mission events are "moments" (S2-10/S2-11, Sprint 4 S4-13): slow-motion, title card, cinematic framing and
 * haptics for the followed spacecraft. Flybys and landings always; for crewed missions also orbit insertions and
 * course-changing burns (Apollo: translunar injection, lunar orbit insertion, lift-off from the Moon, transearth
 * injection) — the story of a crewed flight is its burns. Pure.
 */

const ALWAYS = new Set(['flyby', 'landing']);
const CREWED = new Set(['orbit-insertion', 'maneuver']);

export function isMoment(type: string, crewed: boolean): boolean {
  return ALWAYS.has(type) || (crewed && CREWED.has(type));
}

/**
 * How long the title card is shown around a moment, ms before and after it: two days before a flyby (an approach
 * takes days), three hours before a burn of a crewed mission (Apollo's moments are hours apart).
 */
export function momentWindow(crewed: boolean): { before: number; after: number } {
  return crewed ? { before: 3 * 3_600_000, after: 3_600_000 } : { before: 2 * 86_400_000, after: 12 * 3_600_000 };
}
